import { arrayOf, shape, string } from 'prop-types'

export default shape({
  code: string,
  codes: arrayOf(string),
  description: string,
  headline: string,
  offerId: string,
  packshot: string,
  type: string,
  ribbonText: string,
})
